import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var SparklesIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3L12.2556 7.74441L17 9.5L12.2556 11.2556L10.5 16L8.74441 11.2556L4 9.5L8.74441 7.74441L10.5 3Z M4.5 1.5L5.31027 3.68973L7.5 4.5L5.31027 5.31027L4.5 7.5L3.68973 5.31027L1.5 4.5L3.68973 3.68973L4.5 1.5Z M4.5 12.5L5.04018 13.9598L6.5 14.5L5.04018 15.0402L4.5 16.5L3.95982 15.0402L2.5 14.5L3.95982 13.9598L4.5 12.5Z"
  }));
});
SparklesIcon.displayName = 'SparklesIcon';
export default SparklesIcon;